import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-457499b9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "loader"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { style: { "background-color": "#ffffff", "border-radius": "10px", "box-shadow": "0px 4px 10px rgba(0, 0, 0, 0.1)", "overflow": "hidden" } };
const _hoisted_6 = { style: { "background-color": "#ffffff", "padding": "15px", "text-align": "center" } };
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "padding": "15px 20px 10px 20px", "text-align": "center" } }, [
    /*#__PURE__*/ _createElementVNode("h2", { style: { "margin": "0", "font-size": "16px", "color": "#333" } }, "Gate Pass")
], -1));
const _hoisted_9 = { style: { "text-align": "center" } };
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "padding": "20px", "text-align": "center", "padding-top": "0px" } }, [
    /*#__PURE__*/ _createElementVNode("p", { style: { "color": "red", "font-size": "14px", "margin": "5px 0 0" } }, "*Valid 24 hours only")
], -1));
const _hoisted_12 = { style: { "padding": "15px", "border-top": "1px solid #ddd", "border-bottom": "1px solid #ddd", "display": "flex" } };
const _hoisted_13 = { style: { "width": "50%" } };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin": "5px 0", "font-size": "16px", "color": "#333" } }, "Gate Pass Details ", -1));
const _hoisted_15 = { style: { "margin": "5px 0", "font-size": "16px", "color": "#333" } };
const _hoisted_16 = { style: { "width": "50%" } };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin": "5px 0", "font-size": "16px", "color": "#333" } }, "Branch ", -1));
const _hoisted_18 = { style: { "margin": "5px 0", "font-size": "16px", "color": "#333" } };
const _hoisted_19 = { style: { "padding": "15px", "border-bottom": "1px solid #ddd" } };
const _hoisted_20 = { style: { "display": "flex", "align-items": "center", "margin-top": "10px" } };
const _hoisted_21 = ["src"];
const _hoisted_22 = { style: { "margin": "0", "font-size": "16px", "color": "#333" } };
const _hoisted_23 = { style: { "margin": "0", "font-size": "16px", "color": "#333" } };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin": "10px 0px", "font-size": "14px", "color": "#333" } }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Vehicle Details")
], -1));
const _hoisted_25 = { style: { "margin": "5px 0", "font-size": "14px", "color": "#555" } };
const _hoisted_26 = { style: { "padding": "15px", "border-bottom": "1px solid #ddd" } };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin": "0", "font-size": "16px", "color": "#333", "margin-bottom": "10px" } }, "Customer", -1));
const _hoisted_28 = { style: { "margin": "0", "font-size": "16px", "color": "#333", "margin-bottom": "10px" } };
const _hoisted_29 = { style: { "margin": "5px 0", "font-size": "16px", "color": "#333" } };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "padding": "20px", "text-align": "center", "background-color": "#f4f4f4" } }, [
    /*#__PURE__*/ _createElementVNode("button", { style: { "background-color": "red", "color": "#ffffff", "padding": "10px 20px", "border": "none", "border-radius": "5px", "font-size": "16px", "cursor": "pointer" } }, "Thank you, Visit again!")
], -1));
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { getApiBaseUrl, getAppName } from "../apiConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GatePass',
    setup(__props) {
        // The name is implicitly the file name, or you can set it directly in the setup script with the 'name' option if needed.
        const data = ref(null);
        const loading = ref(true);
        const route = useRoute();
        const error = ref(null);
        const project = getAppName() || process.env.VUE_APP_NAME;
        const loader = ref({
            almulla: "almulla-loader.png",
            ultimate: "ultimate-loader.svg",
            stellantis: "default-loader.gif",
            aljazirah: "default-loader.gif",
            dmc: "default-loader.gif",
        });
        onMounted(async () => {
            try {
                console.log("route", route);
                const param = route.params.id || route.fullPath.split("/").pop();
                const paramId = route.params.gatePassId || '';
                if (!param) {
                    throw new Error("Parameter is missing");
                }
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const passUrl = paramId
                    ? `${baseUrl}/app/gate-pass/gate-pass/${param}/${paramId}`
                    : `${baseUrl}/app/gate-pass/gate-pass/${param}`;
                const response = await axios.get(passUrl);
                data.value = response.data.data;
                console.log("response.data.data?.reasons", response.data.data);
            }
            catch (err) {
                console.error("API request failed:", err);
                error.value = "Failed to load data";
            }
            finally {
                loading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("img", {
                            src: require(`../assets/${loader.value[_unref(project)]}`),
                            alt: "loading..."
                        }, null, 8, _hoisted_2)
                    ]))
                    : (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("img", {
                                        src: data.value?.companyLogoUrl,
                                        alt: "Mitsubishi Motors",
                                        style: { "width": "150px", "height": "auto" }
                                    }, null, 8, _hoisted_7)
                                ]),
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("img", {
                                        src: data.value?.gatePass?.qrCodeLocation,
                                        alt: "QR Code",
                                        style: { "width": "150px", "height": "150px" }
                                    }, null, 8, _hoisted_10)
                                ]),
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("p", _hoisted_15, [
                                            _createElementVNode("strong", null, _toDisplayString(data.value?.gatePass?.gatePassNumber) + " - " + _toDisplayString(data.value?.gatePassIssueDate), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _hoisted_17,
                                        _createElementVNode("p", _hoisted_18, [
                                            _createElementVNode("strong", null, _toDisplayString(data.value?.serviceCenter), 1)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        (data.value?.imageUrl)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: data.value.imageUrl,
                                                alt: "Vehicle Image",
                                                style: { "width": "80px", "height": "auto", "margin-right": "10px" }
                                            }, null, 8, _hoisted_21))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_22, [
                                                _createElementVNode("strong", null, _toDisplayString(data.value?.model), 1)
                                            ]),
                                            _createElementVNode("p", _hoisted_23, _toDisplayString(data.value?.licensePlate), 1)
                                        ])
                                    ]),
                                    _hoisted_24,
                                    _createElementVNode("p", _hoisted_25, _toDisplayString(data.value?.description), 1)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _hoisted_27,
                                    _createElementVNode("p", _hoisted_28, [
                                        _createElementVNode("strong", null, _toDisplayString(data.value?.fullName), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_29, " +" + _toDisplayString(data.value?.primaryPhone), 1)
                                ]),
                                _hoisted_30
                            ])
                        ]))
            ]));
        };
    }
});
